import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Manager',
    component: () => import('../views/Manager.vue'),
    redirect: '/home',  // 重定向到主页
    children: [
      { path: '403', name: 'NoAuth', meta: { name: '无权限' }, component: () => import('../views/manager/403') },
      { path: 'home', name: 'Home', meta: { name: '系统首页' }, component: () => import('../views/manager/Home') },
      { path: 'stats', name: 'Stats', meta: { name: '统计分析' }, component: () => import('../views/manager/Stats') },
      { path: 'admin', name: 'Admin', meta: { name: '管理员信息' }, component: () => import('../views/manager/Admin') },
      { path: 'adminPerson', name: 'AdminPerson', meta: { name: '个人信息' }, component: () => import('../views/manager/AdminPerson') },
      { path: 'password', name: 'Password', meta: { name: '修改密码' }, component: () => import('../views/manager/Password') },
      { path: 'notice', name: 'Notice', meta: { name: '公告信息' }, component: () => import('../views/manager/Notice') },
      { path: 'lawyer', name: 'Lawyer', meta: { name: '律师信息' }, component: () => import('../views/manager/Lawyer') },
      { path: 'todoCenter', name: 'TodoCenter', meta: { name: '待办中心' }, component: () => import('../views/manager/TodoCenter.vue') },
      { path: 'cases', name: 'Cases', meta: { name: '刑事案件' }, component: () => import('../views/cases/Cases.vue') },
      { path: 'civilCases', name: 'CivilCases', meta: { name: '民事案件' }, component: () => import('../views/civil/CivilCases.vue') },
      { path: 'lawyerPerson', name: 'LawyerPerson', meta: { name: '律师个人信息' }, component: () => import('../views/manager/LawyerPerson') },
    ]
  },
  {
    path: '/front',
    name: 'Front',
    component: () => import('../views/Front.vue'),
    children: [
      { path: 'home', name: 'FrontHome', meta: { name: '系统首页' }, component: () => import('../views/front/Home') },
      { path: 'person', name: 'Person', meta: { name: '个人信息' }, component: () => import('../views/front/Person') },
    ]
  },
  { path: '/login', name: 'Login', meta: { name: '登录' }, component: () => import('../views/Login.vue') },
  // 平台控制台（saas-multi-tenant）：仅 SUPER_ADMIN，与业务布局完全独立
  {
    path: '/platform',
    name: 'Platform',
    component: () => import('../views/platform/Platform.vue'),
    redirect: '/platform/tenants',
    children: [
      { path: 'tenants', name: 'PlatformTenants', meta: { name: '律所管理' }, component: () => import('../views/platform/Tenants.vue') },
      { path: 'payconfig', name: 'PlatformPayConfig', meta: { name: '收款配置' }, component: () => import('../views/platform/PayConfig.vue') },
    ]
  },
  // 订阅到期提示页（saas-multi-tenant 5.2：公开，展示收款信息）
  { path: '/subscription-expired', name: 'SubscriptionExpired', meta: { name: '订阅到期' },
    component: () => import('../views/SubscriptionExpired.vue') },
  // vue-router4 通配路由语法（原 path: '*'）
  { path: '/:pathMatch(.*)*', name: 'NotFound', meta: { name: '无法访问' }, component: () => import('../views/404.vue') },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫：后台页面需登录；/login 与律师前台(/front)放行；
// 平台控制台（/platform/**）仅超管可用，超管不进业务布局（saas-multi-tenant）
const WHITE_LIST = ['/login', '/subscription-expired']
router.beforeEach((to, from, next) => {
  if (WHITE_LIST.includes(to.path) || to.path.startsWith('/front')) {
    next()
    return
  }
  const user = JSON.parse(localStorage.getItem('xm-user') || '{}')
  if (!user.token) {
    next('/login')
    return
  }
  if (to.path.startsWith('/platform')) {
    if (user.role !== 'SUPER_ADMIN') {
      next('/')
      return
    }
  } else if (user.role === 'SUPER_ADMIN') {
    next('/platform/tenants')
    return
  }
  next()
})

export default router
